import styled from "styled-components";

import {
  Description,
  StyledEmailWithIcon,
  StyledPrimaryBtn,
} from "pages/Auth/_shared/components/styles";

export const Container = styled.div`
  ${Description} {
    margin-bottom: 24px;
  }

  ${StyledEmailWithIcon} {
    margin-bottom: 8px;
  }
`;

export const FormContainerInner = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${StyledPrimaryBtn} {
    max-width: 100%;
    width: 100%;
  }
`;
